<template lang="pug">
.promo-footer-terms
  FooterPegi.promo-footer-terms__pegi
  TermsList.promo-footer-terms__docs
</template>

<script>
import FooterPegi from "@chronos/battle-teams-2-components/src/components/footer/vue/blocks/FooterPegi";
import TermsList from "@chronos/frontend-base/src/components/terms/TermsList";

export default {
  name: "PromosFooterSocial",
  components: {
    FooterPegi,
    TermsList,
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/promo-footer-terms";
</style>
